import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  catchError,
  concatWith,
  forkJoin,
  map,
  mergeMap,
  of,
  switchMap
} from 'rxjs';
import { AuthActions } from '@components/auth/auth.actions';
import { ProdigyHealthGuidelineActions } from './health-guideline.actions';
import { ProdigyHealthGuidelineService } from './health-guideline.service';

/**
 * Prodigy Health Guideline Effects.
 *
 * @exports
 * @class ProdigyHealthGuidelineEffects
 * @augments {ProdigyHealthGuidelineService}
 */
@Injectable()
export class ProdigyHealthGuidelineEffects extends ProdigyHealthGuidelineService {
  private readonly actions = inject(Actions);

  readonly onAuthLogout_SwitchProfile = createEffect(
    () => {
      return this.actions.pipe(
        ofType(AuthActions.logout, AuthActions.switchProfile),
        map(() => ProdigyHealthGuidelineActions.reset())
      );
    },
    { dispatch: true }
  );

  readonly onFetch = createEffect(
    () => {
      return this.actions.pipe(
        ofType(ProdigyHealthGuidelineActions.fetch),
        switchMap(() =>
          of(
            ProdigyHealthGuidelineActions.updateLoading({
              loading: true
            })
          ).pipe(
            concatWith(
              forkJoin({
                cgadActivity: this.fetchCgadActivity().pipe(
                  catchError((error) => {
                    // eslint-disable-next-line no-console
                    console.error(`Error in fetchCgadActivity fetch`, error);
                    return of(null);
                  })
                ),
                childInsight: this.fetchChildInsight().pipe(
                  catchError((error) => {
                    // eslint-disable-next-line no-console
                    console.error(`Error in fetchChildInsight fetch`, error);
                    return of(null);
                  })
                ),
                parentingApproach: this.fetchParentingApproach().pipe(
                  catchError((error) => {
                    // eslint-disable-next-line no-console
                    console.error(
                      `Error in fetchParentingApproach fetch`,
                      error
                    );
                    return of({
                      count: 0,
                      results: []
                    });
                  })
                )
              }).pipe(
                mergeMap(
                  ({ cgadActivity, childInsight, parentingApproach }) => [
                    ProdigyHealthGuidelineActions.setCgadActivity({
                      cgadActivity: cgadActivity?.proGuidelineCgadActivity ?? []
                    }),
                    ProdigyHealthGuidelineActions.setChildInsight({
                      childInsight: childInsight?.proGuidelineChildInsight ?? []
                    }),
                    ProdigyHealthGuidelineActions.setParentingApproach({
                      parentingApproach: parentingApproach.results
                    }),
                    ProdigyHealthGuidelineActions.updateLoading({
                      loading: false
                    })
                  ]
                )
              )
            )
          )
        )
      );
    },
    { dispatch: true }
  );
}
